import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'page-not-found',
})
export default class PageNotFound extends Vue {

    // -----------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/login');
    }

}
